import {DOMINOES} from 'redux/actionTypes';
import Api from 'services/Api';

import {Groupes} from 'redux/actions';

export const addDomino = (color) => {
	return (dispatch) => {
		dispatch({
			type: DOMINOES.ADD,
			payload: {
				color
			}
		});
	}
}

export const set = (dominoes) => {
	return (dispatch) => {
		return dispatch({
			type: DOMINOES.SET,
			payload: {
				dominoes
			}
		});
	}
}

export const getDominoByGroup = (params) => {
	return (dispatch) => {
		dispatch({
			type: DOMINOES.LOADING,
		});

		Api.get(
			params,
			'domino/by-group',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				dispatch({
					type: DOMINOES.LOADING,
					payload: {
						fetching: false
					}
				});
				return dispatch(set(data.dominoes));
			}
		);
	};
};

export const saveMultiple = (params, callback) => {
	return save(params, callback, true);
}

export const switchColor = (params, callback) => {
	return (dispatch) => {
		dispatch({
			type: DOMINOES.LOADING,
		});

		Api.post(
			params,
			'domino/switch',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				dispatch({
					type: DOMINOES.LOADING,
					payload: {
						fetching: false
					}
				});

				if (typeof callback === 'function') {
					callback();
				}
				dispatch(set(data.dominoes));
				return dispatch(Groupes.setGroupes(data.groups));
			}
		);
	};
}

export const saveSelection = (params, callback) => {
	return (dispatch) => {
		dispatch({
			type: DOMINOES.LOADING,
		});

		Api.post(
			params,
			'domino/update/selection',
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				dispatch({
					type: DOMINOES.LOADING,
					payload: {
						fetching: false
					}
				});

				if (typeof callback === 'function') {
					callback();
				}
				dispatch(set(data.dominoes));
				return dispatch(Groupes.setGroupes(data.groups));
			}
		);
	};
};

export const save = (params, callback, multiple = false) => {
	return (dispatch) => {
		dispatch({
			type: DOMINOES.LOADING,
		});

		Api.post(
			params,
			'domino/add' + (multiple ? '/multiple' : ''),
			(error, data) => {
				if (error) {
					//TODO ERROR
				}
				dispatch({
					type: DOMINOES.LOADING,
					payload: {
						fetching: false
					}
				});

				if (typeof callback === 'function') {
					callback();
				}
				dispatch(set(data.dominoes));
				return dispatch(Groupes.setGroupes(data.groups));
			}
		);
	};
};
